import { UnavailableOption, type UnavailableReason } from "@/components/filters/shared";
import { cx } from "@/utils/cx";

export type PercentileValue = "all" | ">25" | ">50" | ">75";

type PercentileSelectorProps = {
  value: PercentileValue;
  onChange: (value: PercentileValue) => void;
  getUnavailableReason?: UnavailableReason;
  disabled?: boolean;
  className?: string;
};

const OPTIONS: { id: PercentileValue; label: string }[] = [
  { id: "all", label: "All" },
  { id: ">25", label: ">25%" },
  { id: ">50", label: ">50%" },
  { id: ">75", label: ">75%" },
];

export const PercentileSelector = ({
  value,
  onChange,
  getUnavailableReason,
  disabled = false,
  className,
}: PercentileSelectorProps) => {
  return (
    <div
      className={cx(
        "bg-primary border border-secondary rounded-[6px] p-1 flex gap-1 w-full",
        disabled && "opacity-50 pointer-events-none",
        className,
      )}
    >
      {OPTIONS.map((option) => {
        const isActive = option.id === value;
        const unavailableReason = isActive || option.id === "all" ? undefined : getUnavailableReason?.(option.id);
        if (unavailableReason) {
          return (
            <UnavailableOption
              key={option.id}
              reason={unavailableReason}
              className="flex-1 h-9 px-2 py-2 rounded-[6px] text-[13px] font-medium flex items-center justify-center text-fg-disabled_subtle"
            >
              {option.label}
            </UnavailableOption>
          );
        }
        return (
          <button
            key={option.id}
            type="button"
            disabled={disabled}
            onClick={() => onChange(option.id)}
            className={cx(
              "flex-1 h-9 px-2 py-2 rounded-[6px] text-[13px] font-medium transition-colors",
              "flex items-center justify-center",
              isActive ? "bg-[#181d27] text-white" : "bg-transparent text-quaternary hover:text-tertiary",
              disabled && "cursor-not-allowed",
            )}
          >
            {option.label}
          </button>
        );
      })}
    </div>
  );
};
